import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="px-8 lg:px-32 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/fb98196c-71b4-4198-8d06-d68649381e65.png"
              alt="Nexonix"
              className="h-8 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-10">
            <Link
              to="/services"
              className={`text-base font-medium transition-colors duration-200 cursor-pointer ${
                isActive('/services')
                  ? 'text-teal-700'
                  : isScrolled
                  ? 'text-gray-700 hover:text-teal-700'
                  : 'text-gray-900 hover:text-teal-700'
              }`}
            >
              Services
            </Link>
            <Link
              to="/pricing"
              className={`text-base font-medium transition-colors duration-200 cursor-pointer ${
                isActive('/pricing')
                  ? 'text-teal-700'
                  : isScrolled
                  ? 'text-gray-700 hover:text-teal-700'
                  : 'text-gray-900 hover:text-teal-700'
              }`}
            >
              Pricing
            </Link>
            <Link
              to="/why-nexonix"
              className={`text-base font-medium transition-colors duration-200 cursor-pointer ${
                isActive('/why-nexonix')
                  ? 'text-teal-700'
                  : isScrolled
                  ? 'text-gray-700 hover:text-teal-700'
                  : 'text-gray-900 hover:text-teal-700'
              }`}
            >
              Why Us
            </Link>
            <Link
              to="/contact"
              className="px-6 py-2.5 text-base font-medium text-teal-700 border border-teal-700 rounded-full hover:bg-teal-700 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Start Conversation
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-900 cursor-pointer"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <i className="ri-close-line text-2xl"></i>
            ) : (
              <i className="ri-menu-line text-2xl"></i>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-6 space-y-4 border-t border-gray-200 pt-6">
            <Link
              to="/services"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block text-base font-medium transition-colors duration-200 cursor-pointer ${
                isActive('/services') ? 'text-teal-700' : 'text-gray-700 hover:text-teal-700'
              }`}
            >
              Services
            </Link>
            <Link
              to="/pricing"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block text-base font-medium transition-colors duration-200 cursor-pointer ${
                isActive('/pricing') ? 'text-teal-700' : 'text-gray-700 hover:text-teal-700'
              }`}
            >
              Pricing
            </Link>
            <Link
              to="/why-nexonix"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block text-base font-medium transition-colors duration-200 cursor-pointer ${
                isActive('/why-nexonix') ? 'text-teal-700' : 'text-gray-700 hover:text-teal-700'
              }`}
            >
              Why Us
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-6 py-2.5 text-base font-medium text-center text-teal-700 border border-teal-700 rounded-full hover:bg-teal-700 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Start Conversation
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
